import styled, { css } from 'styled-components';
import React, { useRef } from 'react';
const StyledInputWithIcon = ({
  icon,
  placeholder = 'Search or type a command',
  inputClass,
  value,
  type,
  trailing = undefined,
  leading = undefined,
  $fontSize = '',
  $phFontSize = '',
  $phColor = '',
  name = '',
  readOnly = false,
  ogUrlInput = false,
  ...props
}) => {
  const fileInputRef = useRef(null);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const isFileInput = type === 'file';

  return (
    <div className="flex-grow-1 _styled-input">
      {isFileInput ? (
        <InputStyled
          $isFileInput={isFileInput}
          name={name}
          onClick={handleIconClick}
          $fontsize={$fontSize}
          $phfontsize={$phFontSize}
          ogUrlInput={ogUrlInput}
          $phcolor={$phColor}
          {...props}
        >
          {icon}
          <label htmlFor="file-input" className="file-label">
            {value?.name || 'Choose file to import'}
          </label>
          {leading && <div>{leading}</div>}
          <input
            type={type}
            id="file-input"
            placeholder={placeholder}
            name={name}
            className={inputClass}
            ref={fileInputRef}
            readOnly={readOnly}
            {...props}
          />
          {trailing && <div>{trailing}</div>}
        </InputStyled>
      ) : (
        <InputStyled
          $isFileInput={isFileInput}
          {...props}
          name={name}
          ogUrlInput={ogUrlInput}
        >
          {icon}
          {leading && <div>{leading}</div>}
          <input
            name={name}
            type={type}
            placeholder={placeholder}
            className={inputClass}
            value={value ?? ''}
            readOnly={readOnly}
            {...props}
          />
          {trailing && <div>{trailing}</div>}
        </InputStyled>
      )}
    </div>
  );
};

const InputStyled = styled.div`
  padding: ${({ padding }) => padding ?? '9.4px 17px'};
  max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth : '100%')};
  font-size: ${({ fontsize }) => fontsize ?? '18px'};
  font-family: ${({ theme }) => theme.fontFamily};
  width: 100%;
  font-weight: 400;
  border-top-left-radius: 8px;
  border-top-right-radius: ${({ ogUrlInput }) => (ogUrlInput ? '0px' : '8px')};
  border-bottom-right-radius: ${({ ogUrlInput }) =>
    ogUrlInput ? '0px' : '8px'};
  border-bottom-left-radius: 8px;
  border: 1.5px solid
    ${({ theme, islight }) =>
      islight === 'true' ? theme.dark60 : theme.dark70};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.bodyMedium} !important;
  background-color: ${({ theme }) => theme.white};

  &:focus-within {
    color: ${({ theme }) => theme.inputColor};
    border: 1.5px solid
      ${({ theme }) => (theme.isLight ? theme.dark60 : theme.dark40)};
    background-color: ${({ theme }) => theme.white};
  }

  .file-label {
    margin-left: 10px;
    cursor: pointer;
    color: ${({ theme }) => theme.inputColor};
  }

  input[type='file'] {
    display: none;
  }

  input:not([type='file']) {
    border: 0;
    width: 100%;
    margin-left: 5px;
    background-color: ${({ theme }) => theme.white};

    &:valid {
      background-image: none;
    }

    &:focus {
      box-shadow: none;
      outline: none;
      border: 0;
      background-color: ${({ theme }) => theme.white};
    }

    &::placeholder {
      font-weight: 400;
      font-size: ${({ theme }) =>
        theme.$phFontSize || theme.$fontSize || '18px'};
      color: ${({ theme }) => theme.bodyLight};
      opacity: 1;
    }
  }

  input {
    &[type='number'] {
      -moz-appearance: textfield;
      appearance: textfield;
    }

    &[type='number']::-webkit-inner-spin-button,
    &[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &::-ms-reveal {
      display: none;
    }
  }
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.dark80};
      input:not([type='file']) {
        background-color: ${({ theme }) => theme.transparent};
        cursor: not-allowed;
        pointer-events: none;
      }
    `}
`;

export default StyledInputWithIcon;
